import { Component, OnInit, EventEmitter, Input, Output, ElementRef, ViewChild } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { CommonService } from '../../services/common.service';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
import { BlurbService } from '../../services/blurb.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PreparedStatement } from '../../model';
import { FootNote } from '../../model/prepared-statement';
Quill.register('modules/blotFormatter', BlotFormatter);
@Component({
  selector: 'core-blurb-text',
  templateUrl: './blurb-text.component.html',
  styleUrls: ['./blurb-text.component.scss']
})
export class BlurbTextComponent implements OnInit {

  @Input() order;
  @Input() isEditMode;
  @Input() type;
  @Input() PS_IBIS_List: PreparedStatement[] = [];
  @Input() PS_GENERAL_LIST: PreparedStatement[] = [];
  @Input() textAreaData: string = '';
  @Output() modeChange = new EventEmitter();
  @Output() ft_ref_change = new EventEmitter();
  @ViewChild('blurbTextAddNewBlurb', {static: true }) blurbTextAddNewBlurb: ElementRef;

  searchText:string = '';
  todo = [];
  itemList = [];
  dropAreaConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '100px',
    maxHeight: '600px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Select Blurbs / Prepared Statements from the right menu when in edit mode',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: true,
    toolbarPosition: 'top'
  };
  quillModules = {
    blotFormatter: {},
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean'],
    ]
  };
  ft_ref_list:FootNote[] = [];
  modalRef: BsModalRef;
  sortType:string = '';

  constructor(
    public modalService: BsModalService,
    public commonService: CommonService,
    private blurbService: BlurbService
  ) { }

  ngOnInit(): void {
    this.PS_IBIS_List.map((blurb) => {
      blurb['MARK_AS_INVALID'] = this.checkTextIsValid(blurb.TEXT);
    });
    this.sortBlurbList();
  }

  ngOnChanges(change): void{
    if(change.isEditMode){
      this.isEditMode = change.isEditMode.currentValue;
    }
    if(change.order){
      this.order = change.order.currentValue;
    }
  }

  checkTextIsValid(text:string):boolean{
    var footnoteList = (text.match(/<a href=".*?(?=#_ftn\d)(.*?)<\/a>/g) || []);
    var footNoteText = (text.match(/<p class="MsoFootnoteText"><a href=.*?(?=#_ftnref)(.*?)<\/p>/g) || []);
    if(footnoteList.length > 0 || footNoteText.length > 0)
      return true;
    else
      return false;
  }

  // drop() - Append text when object is dropped on area.
  drop(event: CdkDragDrop<string[]>): void {
    if(event.isPointerOverContainer){
      this.textAreaData = this.textAreaData + event.item.data.TEXT + '<br/>';
    }
  }

  // addTextToTextarea() - On click of item, add that text to text area.
  addTextToTextarea(data:PreparedStatement): void{
    this.textAreaData = (this.textAreaData ? this.textAreaData : '') + data.TEXT + '<br/>';
    if(data.REFS){
      data.REFS.forEach(item => {
        let isExist:boolean = false;
        this.ft_ref_list.forEach(ftNote => {
          if(ftNote.CODE === item.CODE) isExist = true;
        });
        if(!isExist) this.ft_ref_list.push(item);
      });
      this.ft_ref_change.emit(this.ft_ref_list);
    }
  }

  // changeToEditMode() - Change to edit mode when no data found.
  changeToEditMode(): void{
    this.isEditMode = !this.isEditMode;
    this.modeChange.emit(this.isEditMode);
  }

  // openModalToAddBlurb() - Open modal to add new blurb.
  openModalToAddBlurb(): void{
    this.modalRef = this.modalService.show(this.blurbTextAddNewBlurb, { backdrop: 'static', class: 'blurb-text-modal-width' });
  }

  // closeNewBlurbModal() - Close add new blurb modal.
  closeNewBlurbModal(): void{
    this.modalRef.hide();
  }

  // updateBlurbsList() - Update blurbs list according to response.
  updateBlurbsList(event): void{
    if(event.modalClose){
      if(event.newBlurb){
        if(event.isEditMode){
          this.PS_GENERAL_LIST.map((blurb, index) => {
            if(blurb.ID === event.newBlurb.ID){
              event.newBlurb['MARK_AS_INVALID'] = this.checkTextIsValid(event.newBlurb.TEXT);
              this.PS_GENERAL_LIST[index] = event.newBlurb;
            }
          });
        }else{
          event.newBlurb['MARK_AS_INVALID'] = this.checkTextIsValid(event.newBlurb.TEXT);
          this.PS_GENERAL_LIST.push(event.newBlurb);
        }
      }
      this.closeNewBlurbModal();
    }
  }

  // editBlurb() - Edit blurb.
  editBlurb(item: PreparedStatement): void{
    this.blurbService.setBlurb(item);
    this.openModalToAddBlurb();
  }

  // sortBlurbList() - Sort blurb list according to blurb type.
  sortBlurbList(): void{
    if(!this.sortType || this.sortType === 'DESC'){
      // Json parsing is done to remove reference because it is creating problem when we are duplicating this block.
      this.PS_GENERAL_LIST = JSON.parse(JSON.stringify(this.PS_GENERAL_LIST)).sort((a, b) => (a['HEADER'] > b['HEADER']) ? 1 : -1);
      this.PS_IBIS_List = JSON.parse(JSON.stringify(this.PS_IBIS_List)).sort((a, b) => (a['HEADER'] > b['HEADER']) ? 1 : -1);
      this.sortType = 'ASC';
    }else{
      // Json parsing is done to remove reference because it is creating problem when we are duplicating this block.
      this.PS_GENERAL_LIST = JSON.parse(JSON.stringify(this.PS_GENERAL_LIST)).sort((a, b) => (a['HEADER'] > b['HEADER']) ? -1 : 1);
      this.PS_IBIS_List = JSON.parse(JSON.stringify(this.PS_IBIS_List)).sort((a, b) => (a['HEADER'] > b['HEADER']) ? -1 : 1);
      this.sortType = 'DESC';
    }
  }
}
